import { render, staticRenderFns } from "./test_cxkq.vue?vue&type=template&id=679c4a80&scoped=true&"
import script from "./test_cxkq.vue?vue&type=script&lang=js&"
export * from "./test_cxkq.vue?vue&type=script&lang=js&"
import style0 from "./test_cxkq.vue?vue&type=style&index=0&id=679c4a80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c4a80",
  null
  
)

export default component.exports